import React from 'react';
import { ModalLayoutContextModel } from './model';

const defaultValue: ModalLayoutContextModel = {};

export const ModalLayoutContext = React.createContext<ModalLayoutContextModel>(defaultValue);

export const useModalLayoutContext = () => React.useContext(ModalLayoutContext);
